import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { UrlBuilder } from '@core/model/url-builder';
import { CapabilityPermissionResponseDto } from '@domain/capability-permission/dtos/capability-permission.response.dto';
import { GetCapabilityPermissionRequestDto } from '@domain/capability-permission/dtos/get-capability-permission.request.dto';

@Injectable({
  providedIn: 'root',
})
export class CapabilityPermissionService extends UrlBuilder {
  constructor(private http: HttpClient) {
    super('capability/permission');
  }

  get(request: GetCapabilityPermissionRequestDto) {
    const queryUrl = `${this.getApiUrl()}/get`;
    return this.http.get<ApiResponse<CapabilityPermissionResponseDto[]>>(
      queryUrl,
      { params: { ...request } },
    );
  }
}
